import axios from '@/plugins/axios'
import { Module } from 'vuex'

const statsModule: Module<any, any> = {
    actions: {
        async loadPosts(_, params) {
            const { data } = await axios.get(
                `/api/stats/workspace/posts?period=${params.period}&start=${params.start}&end=${params.end}`,
            )

            return data
        },
        async loadClicks(_, params) {
            const { data } = await axios.get(
                `/api/stats/workspace/clicks?period=${params.period}&start=${params.start}&end=${params.end}`,
            )

            return data
        },
        async loadLikes(_, params) {
            const { data } = await axios.get(
                `/api/stats/workspace/likes?period=${params.period}&start=${params.start}&end=${params.end}`,
            )

            return data
        },
        async loadComments(_, params) {
            const { data } = await axios.get(
                `/api/stats/workspace/comments?period=${params.period}&start=${params.start}&end=${params.end}`,
            )

            return data
        },
        async loadShares(_, params) {
            const { data } = await axios.get(
                `/api/stats/workspace/reshares?period=${params.period}&start=${params.start}&end=${params.end}`,
            )

            return data
        },
        async getReportBenchmarkStats(_, params) {
            const { data } = await axios.get(
                `/api/stats-derived/report/benchmark/${params.id}?start=${params.start ?? ''}&end=${params.end ?? ''}&period=${params.period ?? ''}`,
            )

            return data
        },
        async getWorkspaceStats(_, params) {
            const url = '/api/stats/workspace' + 
                (params.type ? '/' + params.type : '') +
                '?period=' +
                params.period +
                '&start=' +
                params.start +
                '&end=' +
                params.end +
                '&postPublishStart=' +
                (params.postPublishStart ?? '') +
                '&postPublishEnd=' +
                (params.postPublishEnd ?? '') +
                (params.network ? '&network=' + params.network : '') +
                (params.external ? '&external=' + (params.external ? 1 : 0) : '') +
                (params.hashtagSlug ? '&hashtagSlug=' + params.hashtagSlug : '') +
                (params.campaignTag ? '&campaignTag=' + params.campaignTag : '') +
                (params.workspaceMemberIds && Array.isArray(params.workspaceMemberIds) 
                    ? params.workspaceMemberIds.map(id => `&workspaceMemberIds[]=${id}`).join('') 
                    : '') +
                (params.topics ? '&topics=' + params.topics : '') +
                (params.feeds ? '&feeds=' + params.feeds : '') +
                (params.intervalType ? '&intervalType=' + params.intervalType : '') +
                (params.statusContent ? '&statusContent=' + params.statusContent : '') +
                (params.seatType ? '&seatType=' + params.seatType : '') +
                (params?.tags?.length > 0 ? '&workspaceMemberTags=' + params.tags : '')

            const { data } = await axios.get(url)

            return data
        },
        async getWorkspaceMemberStats(_, params) {
            const url =
                '/api/stats/workspace-member/' +
                params.id +
                (params.type ? '/' + params.type : '');

            const { data } = await axios.get(url, {
                params: {
                    period: params?.period ?? null,
                    start: params?.start ?? null,
                    end: params?.end ?? null,
                    engagementRate: params?.engagementRate ?? null,
                    postPublishStart: params?.postPublishStart ?? null,
                    postPublishEnd: params?.postPublishEnd ?? null,
                    network: params?.network ?? null,
                    external: params?.external ?? null,
                    limit: params?.limit ?? null,
                    intervalType: params?.intervalType ?? null
                }
            });
            return data
        },
        async getContentStats(_, params) {
            const url =
                '/api/stats/content/' + params.id +
                (params.type ? '/' + params.type : '') +                
                '?period=' + params.period +
                (params.network ? '&network=' + params.network : '') +
                (params.start ? '&start=' + params.start : '') +
                (params.end ? '&end=' + params.end : '') + 
                (params.postPublishStart ? '&postPublishStart=' + params.postPublishStart : '') +
                (params.postPublishEnd ? '&postPublishEnd=' + params.postPublishEnd : '')

            const { data } = await axios.get(url)

            return data
        },
        async getReportStats(_, params) {
            const url =
                '/api/stats/report/' + params.id +
                (params.type ? '/' + params.type : '') +                
                '?period=' + params.period +
                (params.profileUuid ? '&profileUuid=' + params.profileUuid : '') +
                (params.start ? '&start=' + params.start : '') +
                (params.end ? '&end=' + params.end : '')
            
            const { data } = await axios.get(url)

            return data
        },
        async getReportRankAndChangeStats(_, params) {
            const url =
                '/api/stats/report-rank-and-change/' + params.id +
                '?period=' + params.period +
                (params.end ? '&end=' + params.end : '') + 
                (params.rankBy ? '&rankBy=' + params.rankBy : '')
                
            const { data } = await axios.get(url)

            return data
        },
        async getReportMarketingMixStats(_, params) {
            const url =
                '/api/stats/report-marketing-mix/' + params.id +
                '?' + (params.start ? '&start=' + params.start : '') + 
                	(params.end ? '&end=' + params.end : '')
                
            const { data } = await axios.get(url)

            return data
        },
    },
}

export default statsModule
